import * as _ from "lodash";
import { history } from "~/navigation/CustomBrowserRouter"

let hubUrl: string | undefined = undefined;

export const VssNavigation = {
    bridgeVssNavigation: async () => {
        const nav = await VSS.getService<IHostNavigationService>(VSS.ServiceIds.Navigation);
        history.listen((listener) => {
            nav.replaceHash(listener.location.pathname);
        });

        nav.onHashChanged(VssNavigation.onHashChanged);

        const urlParams = await nav.getCurrentState();
        const currentHash = await nav.getHash();
        VssNavigation.onHashChanged(currentHash || urlParams["path"]);
    },


    onHashChanged: (urlHash: string) => {
        if (_(history.location.pathname).trim("/") !== _(urlHash).trim("/")) {
            history.replace({ pathname: urlHash });
        }
    },

    getHubUrl: (): string => {
        if (hubUrl === undefined) {
            if (VSS.isMock) {
                hubUrl = "";
            } else {
                const webCtx = VSS.getWebContext();
                const extCtx = VSS.getExtensionContext();
                hubUrl = `${webCtx.host.uri}${webCtx.project.name}/_apps/hub/${extCtx.publisherId}.${extCtx.extensionId}.product-catalog-web-hub#`;
            }
        }

        return hubUrl;
    },

    getCurrentUrl: (): string => {
        let currentUrl = window.location.href;
        if (!VSS.isMock) {
            const webCtx = VSS.getWebContext();
            const extCtx = VSS.getExtensionContext();
            const pathname: string = history.location.pathname;
            currentUrl = `${webCtx.host.uri}${webCtx.project.name}/_apps/hub/${extCtx.publisherId}.${extCtx.extensionId}.product-catalog-web-hub#${pathname}`;
        }

        return currentUrl;
    }
}
